<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    lazy
    transition="slide-x-transition"
    full-width
    min-width="240px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        :error-messages="errorMessages"
        :required="required"
        @focus="focused"
        @input="updateSelf"
        :value="time"
        :label="label"
        prepend-inner-icon="access_time"
        :disabled="disabled"
        :append-icon="clearable ? 'close' : ''"
        @click:append="handleClear"
        v-on="on"
        :rules="rules"
      ></v-text-field>
    </template>
    <v-time-picker ref="picker" v-model="timeStore" format="24hr" @change="updateSelf"></v-time-picker>
  </v-menu>
</template>

<script>
export default {
  name: "DateTimeInput",
  model: {
    prop: "time",
    event: "input"
  },
  props: {
    label: String,
    time: String,
    errorMessages: String,
    required: Boolean,
    disabled: false,
    clearable: false,
    rules: Array
  },
  data() {
    return {
      menu: false,
      timeStore: ""
    };
  },
  methods: {
    updateSelf() {
      this.menu = false;
      //Fix cause picker doesn't default back to hour when re-picking...?
      this.$refs.picker.selectingHour = true;
      this.$emit("input", this.timeStore);
    },
    focused() {
      this.$emit("focused");
    },
    handleClear() {
      if(this.clearable) {
        this.$emit("input", "");
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
